// Lib
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

// Utils
import { stopPropagationOnly } from '../../../utils/domUtil';
import { getTitle } from '../../../../common/elements/utils/elementPropertyUtils';
import { hasCommandModifier } from '../../../utils/keyboard/keyboardUtility';
import { getCloneDescription } from '../cloneUtils';

// Selectors
import { getCurrentBoardIdFromState } from '../../../reducers/currentBoardId/currentBoardIdSelector';
import { cloneInstanceBoardIdsSelector } from '../cloneInstancesSelector';
import { getElement } from '../../selectors/elementSelector';

// Actions
import { navigateToBoard } from '../../../reducers/navigationActions';

// Components
import BreadcrumbIcon from '../../../workspace/breadcrumbs/Components/BreadcrumbIcon';
import Icon from '../../../components/icons/Icon';

// Types
import { ImMNElement } from '../../../../common/elements/elementModelTypes';

// Styles
import './ElementCloneInstancesPopupContentMultiBoards.scss';

const CloneInstanceBoardEntry = (props: { elementId: string }) => {
    const { elementId } = props;

    const element = useSelector((state) => getElement(state, props));
    const currentBoardId = useSelector(getCurrentBoardIdFromState);

    const dispatch = useDispatch();
    const dispatchNavigateToBoard = (event: React.MouseEvent<HTMLDivElement>) =>
        dispatch(
            navigateToBoard({
                boardId: elementId,
                keepSelection: false,
                newTab: hasCommandModifier(event),
                navigationSource: undefined,
            }),
        );

    if (elementId === currentBoardId) return null;

    return (
        <div className="CloneInstanceBoardEntry" onClick={dispatchNavigateToBoard}>
            <BreadcrumbIcon element={element} />
            <div className="title">{getTitle(element)}</div>
            <Icon name="chevron-right" />
        </div>
    );
};

const ElementCloneInstancesPopupContentMultiBoards = (props: {
    element: ImMNElement;
    reachableInstanceCount: number;
}) => {
    const { element, reachableInstanceCount } = props;

    const reachableInstanceBoardIds = useSelector((state) => cloneInstanceBoardIdsSelector(state, props));

    return (
        <div className="ElementCloneInstancesPopupContentMultiBoards" onClick={stopPropagationOnly}>
            <p className="copies-description">{getCloneDescription(element, reachableInstanceCount)}</p>
            {reachableInstanceBoardIds.map((boardId: string) => (
                <CloneInstanceBoardEntry key={boardId} elementId={boardId} />
            ))}
        </div>
    );
};

export default ElementCloneInstancesPopupContentMultiBoards;
